export default function windowEnv(key, defaultValue = '') {
  if (window.env) {
    return window.env[key] || defaultValue;
  }
  return defaultValue;
}
